import { AuthTokens } from './types';
import { resetAnalyticsUser } from 'src/services/analytics';

const ACCESS_TOKEN_KEY = 'a_token';
const REFRESH_TOKEN_KEY = 'r_token';

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const saveAuthTokens = (tokens: AuthTokens) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
};

// The single chokepoint every sign-out path (explicit logout, 401
// auto-redirect, refresh failure) already runs through — resetting analytics
// here means a shared machine never stitches the next login onto this
// session's distinct_id, without having to wire each caller separately.
export const clearAuthTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  resetAnalyticsUser();
};
